import type { Serializer } from "./serializer";

export type JsonValue = string | number | boolean | null | readonly JsonValue[] | { readonly [key: string]: JsonValue };

/** Serializer metadata can be any JSON-representable object. */
export type SerializerSchema = { readonly [key: string]: JsonValue };

export const getSerializerSchema = <T>(serializer: Serializer<T>): SerializerSchema => serializer.schema;

/** Tagged values preserve constants that JSON itself cannot represent. */
export const describeSerializerLiteral = (value: unknown): SerializerSchema => {
  if (value === undefined) return { kind: "undefined" };
  if (typeof value === "bigint") return { kind: "bigint", value: value.toString() };
  if (typeof value === "number") {
    if (Object.is(value, -0)) return { kind: "specialNumber", value: "-0" };
    if (Number.isNaN(value)) return { kind: "specialNumber", value: "NaN" };
    if (value === Infinity) return { kind: "specialNumber", value: "Infinity" };
    if (value === -Infinity) return { kind: "specialNumber", value: "-Infinity" };
    return { kind: "literal", value };
  }
  if (value === null || typeof value === "string" || typeof value === "boolean") {
    return { kind: "literal", value };
  }
  // oneOf uses reference equality for objects/functions/symbols. Their identities
  // cannot be represented by a portable structural description.
  return { kind: "unknown", reason: "non-literal-option" };
};
